function showAlertModal(data) {
  const modal = $('.modal-background')
  modal.css('display', 'flex').html(data.message);
  modal.find('.js-continue-btn').click((e) => {
    e.preventDefault();
    $('.prices-add-to-cart-actions button').first().trigger('click', {destroyBasket: true});
    modal.empty().hide();
  });
  modal.find('.js-not-continue-btn').click((e) => {
    e.preventDefault();
    modal.hide();
  });
}

module.exports = {
  showAlertModal: showAlertModal
};


// WEBPACK FOOTER //
// ./assets/scripts/product/giftCardHelper.js